module.exports = __webpack_public_path__ + "static/media/Regigigas_gaussian2.5f7828e1.png";